import { DOMHelper } from "../Helpers/DOMHelper.js";
import { Modal } from "./Modal.js";

export class MissingFields {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAt = "missing-fields";
    }

    init() {
        this.missingFieldsModal = new Modal(this.app, "missing-fields", this.getHtml(), null, "missing-fields-class");
        this.missingFieldsModal.init();
    }

    showMissingFields(fields) {
        let missing = {
            ".tradein-condition": "Condition",
            ".ytiMiles": "Mileage",
        };

        let html = "";
        fields.forEach((field, cont) => {
            html += "<i>" + (cont + 1) + ". " + missing[field] + "</i><br>";
        });

        DOMHelper.setInnerHTML(this.getSelector(".missing-fields-value"), html);
    }

    getHtml() {
        return `<div class="missing-fields">
    <p>Please fill out the following fields to obtain your trade-in value.</p><br>

    <p class="missing-fields-value"></p>
</div>`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAt + " " + selector);
    }
}
